import { Route } from '../../../../../domain/route/Route';
import { InTransit } from './InTransit';

type FinishedProps = {
  selectedRoute: Route;
  isOnline?: boolean;
};

export const Finished = ({ selectedRoute, isOnline }: FinishedProps) => {
  return <InTransit selectedRoute={selectedRoute} isOnline={isOnline} />;
};
